//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Anchor, Icon } from 'unison';

import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import ContentSourceType from '@models/ContentSourceType';
import { Mixins } from '@theme/mixins';

import { InstagramWebLinks } from 'app/constants/social-links';

interface Props {
  className?: string;
  sourceName: string;
  sourceType: ContentSourceType;
}

const InstagramLinkoutButton = ({ sourceName, sourceType }: Props) => {
  const sourceLink =
    sourceType === ContentSourceType.USER
      ? InstagramWebLinks.getUserLink(sourceName)
      : InstagramWebLinks.getHashtagLink(sourceName);
  const sourceText =
    sourceType === ContentSourceType.USER ? `@${sourceName}` : `#${sourceName}`;

  return (
    <SmallTooltip
      content='View on Instagram'
      placement='top'
      target={
        <InstagramLink href={sourceLink} target='_blank'>
          <span className='cu-text-truncate cu-mx-1'>{sourceText}</span>
          <LinkIcon name='linkout' />
        </InstagramLink>
      }
    />
  );
};

const InstagramLink = styled(Anchor)`
  ${Mixins.Text.LinkPrimary}
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const LinkIcon = styled(Icon)`
  && {
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export default InstagramLinkoutButton;
